// extracted by mini-css-extract-plugin
export default {"info":"NgSYQk","date":"KdM1Ph","number":"uEvCOY"};